export default __webpack_public_path__ + "static/media/pixellab--graphic-design--04--600x450.6f95a356.jpg";